import { Box, Button, Grid } from '@material-ui/core';
import { useRef } from 'react';
import { useStyles } from './form-login-styles';
import { useFormLoginValidation } from './form-login-validation';
import { TextFieldSaurus } from 'views/components/controles/inputs';
import { CircularLoading, makeUtilClasses, useThemeQueries } from 'views';
import React from 'react';
import {
  DefaultFormRefs,
  DefaultFormProps,
} from '../../utils/form-default-props';
import { LoginFormModel } from 'model/app';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

export const FormLogin = React.forwardRef<
  DefaultFormRefs<LoginFormModel>,
  DefaultFormProps<LoginFormModel>
>((props: DefaultFormProps<LoginFormModel>, refs) => {
  const txtEmail = useRef<HTMLInputElement>();
  const { FormLoginYupValidation } = useFormLoginValidation();
  const utilClasses = makeUtilClasses();
  const classes = useStyles();
  const { isMobile } = useThemeQueries();

  const {
    handleSubmit,
    control,
    formState: { errors, touchedFields },
    reset,
    getValues
  } = useForm<LoginFormModel>({
    resolver: yupResolver(FormLoginYupValidation),
    criteriaMode: 'all',
    mode: 'onSubmit' && 'onTouched',
  });

  const onSubmit = (form: LoginFormModel) => {
    props.onSubmit(form);
  };

  React.useImperativeHandle(refs, () => ({
    submitForm: () => {
      handleSubmit(onSubmit)();
    },
    resetForm: () => {
      reset({ login: getValues('login'), senha: '' });
      if (!isMobile) txtEmail?.current?.focus();
    },
    fillForm: (model: LoginFormModel) => {
      reset({ ...model });
      if (!isMobile) txtEmail?.current?.focus();
    },
  }));

  return (
    <>
      <div className={utilClasses.formContainer}>
        {props.loading && props.showLoading ? (
          <CircularLoading tipo="FULLSIZED" />
        ) : null}
        <form
          onSubmit={handleSubmit(onSubmit)}
          className={`${classes.formContainer} ${props.loading ? utilClasses.controlLoading : ''
            }`}
        >
          <Grid container style={{ maxWidth: '100%'}} direction='column' justifyContent='center'>
            <Grid item xs={12} style={{marginBottom: 30}}>
              <Controller
                name="login"
                control={control}
                render={({ field }) => (
                  <TextFieldSaurus
                    tipo="USUARIO"
                    disabled={props.loading}
                    fullWidth={true}
                    showStartAdornment={true}
                    inputRef={txtEmail}
                    allowSubmit={false}
                    autoComplete={'off'}
                    label="Usuário"
                    placeholder="Digite o usuário"
                    error={Boolean(errors.login && errors.login.message)}
                    helperText={
                      touchedFields.login || errors.login
                        ? errors.login?.message
                        : undefined
                    }
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Box
                mb={Boolean(touchedFields.senha && errors.senha) ? 0 : 1.5}
              >
                <Controller
                  name="senha"
                  control={control}
                  render={({ field }) => (
                    <TextFieldSaurus
                      tipo="PASSWORD"
                      allowSubmit={true}
                      disabled={props.loading}
                      showStartAdornment={true}
                      fullWidth={true}
                      autoComplete={'off'}
                      label="Senha"
                      placeholder="Digite sua Senha"
                      error={Boolean(errors.senha && errors.senha.message)}
                      helperText={
                        touchedFields.senha || errors.senha
                          ? errors.senha?.message
                          : undefined
                      }
                      {...field}
                    />
                  )}
                />
              </Box>
            </Grid>
          </Grid>
          <Button style={{ display: 'none' }} type="submit"></Button>
        </form>
      </div>
    </>
  );
});
